module.exports = __webpack_public_path__ + "static/img/volunteergiftslist.2d617dc6.png";